import type { FC, PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";
import type { Location } from "src/types/shared/cookies";
import { HeaderSection } from "./HeaderSection";

const StyledLocCarouselListSection = styled.section`
  border-bottom: 1px solid ${(props) => props.theme.colors.borderPrimary};
  border-top: 1px solid ${(props) => props.theme.colors.borderPrimary};
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing(8, 0)};
  width: 100%;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    padding: ${(props) => props.theme.spacing(10, 0)};
  }
`;

interface Props {
  className?: string | undefined;
  headerContent?: ReactNode;
  placement?: string;
  userLocation?: Maybe<Location>;
  setUserLocation?: (location: Location) => void;
}

/**
 * Reusable Section Wrapper with Similar Header Content for Location-Controlled Sections on Category Grouping
 */
export const LocCarouselListSection: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  headerContent,
  placement,
  userLocation,
  setUserLocation,
}) => (
  <StyledLocCarouselListSection className={className}>
    <HeaderSection
      headerContent={headerContent}
      location={userLocation}
      placement={placement}
      setLocation={setUserLocation}
    />
    {children}
  </StyledLocCarouselListSection>
);
